import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '../layout/Box';
import { iconSizeMap, defaultIconSize } from './iconConst';
export const IconPlaceholder = ({ size = defaultIconSize, sizeOverride, }) => {
    const resultSize = sizeOverride || iconSizeMap[size];
    return _jsx(Box, { shrink: 0, width: resultSize, height: resultSize });
};
